import React from "react";

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <g clip-path="url(#clip0)">
        <path d="M2.123 4.612V14h9.754V4.612H2.123zm3.32 7.293h-.82V6.623h.82v5.282zm1.967 0h-.82V6.623h.82v5.282zm1.966 0h-.82V6.623h.82v5.282zM8.774 1.537V0H5.226v1.537H1.244v2.255h11.512V1.537H8.774zm-.82 0H6.046V.82h1.908v.717z"></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H14V14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
